export const ANONYMOUS_LENDER_LABEL = "Verified Lender";

export const getAnonymousLenderLabel = (lender?: { uuid?: string }) => {
  if (!lender?.uuid) return ANONYMOUS_LENDER_LABEL;
  return `Lender #${lender.uuid.slice(-6).toUpperCase()}`;
};
